/**
 * CheckToggle Widget
 * 
 * This widget adds a "check all | check none" toggle below a group of checkboxes.
 * Call this widget on the parent group, eg $('.group').checkToggle() and it will trigger for any of the checkboxes contained.
 */
(function($){
	$.widget('ui.checkToggle', {
		/**
		 * Build the element
		 */
		_create: function(){
			var self = this,
				wrapper = this.wrapper = $('<div class="checktoggle-wrapper">[<a class="fakelink checkToggle-all">check all</a>] [<a class="fakelink checkToggle-none">check none</a>]</div>');
			this.element.after(this.wrapper);
			
			this.elmCheckAll = wrapper.find('.checkToggle-all');
			this.elmCheckNone = wrapper.find('.checkToggle-none');
			
			this.elmCheckAll.bind('click', { cTObj: this }, function(event){ 
				event.data.cTObj.checkAll();
			});
			this.elmCheckNone.bind('click', { cTObj: this }, function(event){ 
				event.data.cTObj.checkNone();
			});
		},
		
		/**
		 * Check all of the checkboxes
		 */
		checkAll: function(){
			this.element.find(':checkbox').each(function(){
				$(this).attr('checked','checked').trigger('change');
			});
		},
		
		/**
		 * Check none of the checkboxes
		 */
		checkNone: function(){
			this.element.find(':checkbox').each(function(){
				$(this).removeAttr('checked').trigger('change');
			});
		}
	});
})( jQuery );